<template>
  <div class="photo-gallery-item-box">
    <img @click="goPhotoDetail" :src="newPhoto.url" />
    <h5>{{ newPhoto.title }}</h5>
    <Tag v-for="item in newPhoto.labels" :key="item.id" :label="item" />
  </div>
</template>

<script>
import Tag from "@/components/Tag";

export default {
  components: { Tag },
  props: {
    photo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goPhotoDetail() {
      window.location.href = `/meinvtupian/${this.photo.album.contentId}.html`;
    },
  },
  computed: {
    newPhoto() {
      let labels = this.photo.album.labels ? this.photo.album.labels : [];
      labels = labels.filter((item) => {
        return item.level > 1;
      });

      return {
        url: this.photo.album.cover137.url,
        title: this.photo.album.title,
        labels,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/stylefunc";

.photo-gallery-item-box {
  padding: 5px;
  box-shadow: 0 0 5px #d6d6d6;
  background-color: white;
  img {
    width: 137px;
    cursor: pointer;
  }
  h5 {
    width: 137px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    line-height: 32px;
  }
}
.photo-gallery-item-box:hover {
  transform: translateY(-10px);
  box-shadow: 0 0 5px 5px #d6d6d6;
}
</style>



// WEBPACK FOOTER //
// src/components/PhotoGalleryItem.vue